import { polyfill, trustPolicies } from '../Sanitizer.js';
export const polyfilled = polyfill();
export { trustPolicies };
